import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const oiProfileSvg = (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4.52501 10.7174H15.025V12.0652H4.525C4.23505 12.0652 4 11.7821 4 11.3913C4 11.0005 4.23506 10.7174 4.52501 10.7174Z"
            fill="currentColor" />
        <path
            d="M12.025 15.4348H22.525C22.8149 15.4348 23.025 15.7179 23.025 16.1087C23.025 16.4995 22.8149 16.7826 22.525 16.7826H12.025V15.4348Z"
            fill="currentColor" />
        <path
            d="M14.925 6H8.52501C8.23507 6 7.925 6.28311 7.925 6.67391C7.925 7.0647 8.23507 7.34783 8.52501 7.34783H14.925V6Z"
            fill="currentColor" />
        <path
            d="M18.525 20.1522L12.025 20.1522V21.5L18.525 21.5C18.8149 21.5 19.125 21.2169 19.125 20.8261C19.125 20.4353 18.8149 20.1522 18.525 20.1522Z"
            fill="currentColor" />
    </svg>

)

const OiProfile: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props} style={{ fontSize: '28px' }}>
        {oiProfileSvg}
    </SvgIcon>
)

export default OiProfile